import * as React from 'react'

const ArrowDownSVGTwoG = props => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      width={props.width}
      height={props.width}
      preserveAspectRatio='xMinYMin meet'
      {...props}
    >
      <path
        d='m15.48 13.23-3.79-5.05H6.08c-.96 0-1.44 1.16-.76 1.84l5.18 5.18c.83.83 2.18.83 3.01 0l1.97-1.97Z'
        opacity={0.4}
      />
      <path d='M17.92 8.18h-6.23l3.79 5.05 3.21-3.21c.67-.68.19-1.84-.77-1.84Z' />
    </svg>
  )
}

export default ArrowDownSVGTwoG
